module.exports = __webpack_public_path__ + "img/onboarding_slide_2.b3820989.jpeg";